import React, { useState } from 'react';
import { Alert } from '@ds/react-components';
import { withStyles } from '@material-ui/core';
import * as moment from 'moment';

const styles = (theme) => ({
  Title: {
    margin: '0px',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
  },
  Content: {
    color: theme.palette.xpl.text.secondary,
    textAlign: 'left',
    fontSize: '12px',
  },
  List: {
    listStyleType: 'disc',
    margin: '0px',
    padding: '0px 0px 0px 20px',
  },
  //TODO: Need update Alert in ds-react lib, then we can remove the style.
  Alert: {
    borderLeftWidth: '0px',
    backgroundColor: theme.palette.xpl.message.information.background,
    '& h3': {
      color: theme.palette.common.black,
    },
    '& svg': {
      color: theme.palette.common.black,
    },
  },
});

const PleaseNote = (props) => {
  const { classes, localisation } = props;
  const { dateFormat } = localisation.locales;
  const [showPleaseNote, setShowPleaseNote] = useState(true);
  return (
    <>
      {showPleaseNote ? (
        <Alert
          className={classes.Alert}
          onClose={() => {
            setShowPleaseNote(false);
          }}
          role="banner"
          variant="success">
          <h3 className={classes.Title}> Please Note</h3>
          <div className={classes.Content}>
            <div>Suspension finish dates are inclusive.</div>
            <br />
            <div>This means:</div>
            <ul className={classes.List}>
              <li>
                To suspend a client for one week from tomorrow, enter a start
                date of {moment().add(1, 'days').format(dateFormat)} and an end
                date of {moment().add(1, 'weeks').format(dateFormat)}.
              </li>
              <li>
                To suspend a client for one month from tomorrow, enter a start
                date of {moment().add(1, 'days').format(dateFormat)} and an end
                date of {moment().add(1, 'months').format(dateFormat)}.
              </li>
              <li>
                Suspensions not in line with payment schedule will result in
                pro-rata payments.
              </li>
            </ul>
          </div>
        </Alert>
      ) : (
        <></>
      )}
    </>
  );
};

export default withStyles(styles)(PleaseNote);
